import { Component, OnInit, Renderer2, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";

let count = 0;

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  private script: any;

  constructor(
    private router: Router,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private injectedDocument: Document,
  ) {}

  // ngOnInit() {

  //   if (count) { return; }
  //   this.loadScript('//counter.top.ge/counter.js');

  //   count += 1;

  // }

  navigateToTermsAndConditions() {
    this.router.navigate(["/terms-and-conditions"]);
  }

  private loadScript(url: string): void {
    this.script = this.renderer2.createElement("script");
    this.script.src = url;
    this.renderer2.appendChild(this.injectedDocument.body, this.script);
  }
}
